import { Menu } from 'lucide-react'

interface MobileHeaderProps {
  onHamburger: () => void
}

export function MobileHeader({ onHamburger }: MobileHeaderProps) {
  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-sidebar-border bg-sidebar px-4 md:hidden">
      <button
        onClick={onHamburger}
        aria-label="Buka menu"
        className="rounded-md p-2 text-sidebar-foreground hover:bg-sidebar-accent transition-colors"
      >
        <Menu className="h-5 w-5" />
      </button>

      <span className="font-semibold text-sidebar-foreground">Oktaafd</span>

      {/* Spacer to keep title centered */}
      <div className="w-9" />
    </header>
  )
}
